module.exports = __webpack_public_path__ + "static/retail-content-image-2-b25362183d6d6d8b358a23805c052011.jpg";